export var component = {
    article: {
        container: "article",
        title: "articleTitle",
        description: "articleDescription",
        body: "articleBody",
        programTitle: "articleProgramTitle",
    },
    banner: {
        error: "bannerError",
    },
    basic: {
        container: "basic",
        title: "basicTitle",
        description: "basicDescription",
        body: "basicBody",
        programTitle: "basicProgramTitle",
    },
    contest: {
        container: "contest",
        title: "contestTitle",
        description: "contestDescription",
        body: "contestBody",
        programTitle: "contestProgramTitle",
    },
    interactive: {
        container: "interactive",
        title: "interactiveTitle",
        description: "interactiveDescription",
        body: "interactiveBody",
        programTitle: "interactiveProgramTitle",
    },
    participate: {
        container: "participate",
        title: "participateTitle",
        description: "participateDescription",
        body: "participateBody",
        programTitle: "participateProgramTitle",
    },
    programsPage: {
        container: "programsPage",
        popular: "programsPagePopularPrograms",
        onAir: "programsPageOnAirPrograms",
        search: {
            channel: "programsPageSearchChannel",
            category: "programsPageSearchCategory",
            text: "programsPageSearchText",
        },
    },
    homepage: "page",
    dynamicHero: "dynamicHero",
    dynamicHeroTitle: "dynamicHeroTitle",
    dynamicHeroDescription: "dynamicHeroDescription",
    dynamicHeroAirTime: "dynamicHeroAirTime",
    dynamicHeroAffixedCountdown: "dynamicHeroAffixedCountdown",
    dynamicHeroImage: "dynamicHeroImage",
    video: "video",
    videoTitle: "videoTitle",
    videoDescription: "videoDescription",
    videoDateAndDuration: "videoDateAndDuration",
    player: "player",
    playlist: "playlist",
    program: "program",
    airTime: {
        today: "airTimeToday",
        tonight: "airTimeTonight",
        live: "airTimeLive",
        other: "airTimeOther",
    },
    vtmgoButton: {
        live: "vtmgoButtonLive",
        onDemand: "vtmgoButtonOnDemand",
    },
    vtmGoLink: "vtmgoLink",
    contentCollection: {
        fixed: "contentCollectionFixed",
        horizontal: "contentCollectionHorizontal",
        highlights: "contentCollectionHighlights",
        highlightsTwo: "contentCollectionHighlightsTwo",
        experienceHighlights: "contentCollectionExperienceHighlights",
        extra: "contentCollectionExtra",
        extraTwo: "contentCollectionExtraTwo",
        extraThree: "contentCollectionExtraThree",
        extraFour: "contentCollectionExtraFour",
        extraFive: "contentCollectionExtraFive",
        extraSix: "contentCollectionExtraSix",
        extraSeven: "contentCollectionExtraSeven",
        extraEight: "contentCollectionExtraEight",
        popularPrograms: "contentCollectionPopularPrograms",
        popularOnVtm: "contentCollectionPopularOnVtm",
        movies: "contentCollectionMovies",
        recentVideos: "contentCollectionRecentVideos",
        topPicks: "contentCollectionTopPicks",
        teams: "contentCollectionTeams",
        team: "contentCollectionTeam",
        comingSoon: "contentCollectionComingSoon",
        onAir: "contentCollectionOnAir",
        season: "contentCollectionSeason",
        customCollection: "contentCollectionCustom",
        ticketsCollection: "contentCollectionTickets",
    },
    teams: {
        collection: "contentCollectionHorizontalTeams",
        menu: "teamMenuTabs",
    },
    card: "card",
    personCard: "personCard",
    vtmGoCard: "vtmGoEpisodeCard",
    vtmGoMyListButton: "vtmGoMyListButton",
    topResultCard: "topResultCard",
    topPicksCard: "topPicksCard",
    topPicks: "topPicks",
    vtmGoBanner: "vtmGoBanner",
    vtmBanner: "vtmBanner",
    CPBD: {
        banner: "CPBDBanner",
        myListButton: "myListButton",
    },
    hero: {
        myListButton: "myListButton",
    },
    vtmNieuwsBanner: "vtmNieuwsBanner",
    vtmGoPlusbanner: "vtmGoPlusBanner",
    newsLetterBanner: "newsLetterBanner",
    vtm3Banner: "vtm3Banner",
    mainNav: "mainNav",
    mainNavColorBackdrop: "mainNavColorBackdrop",
    boxcoverCard: "boxcoverCard",
    dividerBoxcoverCard: "dividerBoxcoverCard",
    programsGrid: "programsGrid",
    programSearchResultsGrid: "programSearchResultsGrid",
    mainMobileNav: "mainMobileNav",
    logo: {
        VTM: "vtmLogo",
        VTM2: "vtm2Logo",
        VTM3: "vtm3Logo",
        VTM4: "vtm4Logo",
        NEWS: "News",
        VTMGOEXCLUSIVES: "Vtm Go exclusive",
        vtmGo: "vtmGo",
        vtmNieuws: "vtmNieuws",
        vtmKids: "vtmKids",
        vtmKoken: "vtmKoken",
        vtmShop: "vtmShop",
        vtmTickets: "vtmTickets",
    },
    tracer: {
        vtm: "vtmTracer",
        vtm2: "vtm2Tracer",
        vtm3: "vtm3Tracer",
        vtm4: "vtm4Tracer",
    },
    brandFooter: "brandFooter",
    mainFooter: "mainFooter",
    mainFooterNavList: "mainFooterNavList",
    companyFooter: "companyFooter",
    embed: {
        qualifio: {
            slot: "embedQualifioSlot",
            content: "embedQualifioContentArea",
            full: "embedQualifioFull",
        },
        iframe: {
            slot: "embedIframeSlot",
            content: "embedIframeContentArea",
            full: "embedIframeFull",
        },
        spotify: {
            show: "embedSpotifySlotShow",
            track: "embedSpotifySlotTrack",
            playlist: "embedSpotifySlotPlaylist",
            episode: "embedSpotifySlotEpisode",
            album: "embedSpotifySlotAlbum",
        },
    },
    infoBanner: "infoBanner",
    search: {
        nav: "mainNavSearch",
        compontent: "searchComponent",
        input: "searchInput",
        results: "searchResults",
        closeButton: "searchCloseButton",
        clearButton: "searchClearButton",
    },
    ticketHighlight: "ticketHighlight",
};
export var result = {
    loading: "loading",
    fail: "fail",
    success: "success",
};
export var action = {
    dynamicHeroTitleLink: "dynamicHeroTitleLink",
    dynamicHeroGoButton: "dynamicHeroGoButton",
    dynamicHeroArrowCta: "dynamicHeroArrowCta",
    videoProgramLink: "videoProgramLink",
    cardLink: "cardLink",
    topCardLink: "topCardLink",
    topPicksCardLink: "topPicksCardLink",
    boxcoverCardLink: "boxcoverCardLink",
    navLink: "navLink",
    footerGoCta: "footerGoCta",
    footerCta: "footerCta",
    socialLink: "socialLink",
    legalLink: "legalLink",
    cookieSettings: "cookieSettings",
    dpgLogoLink: "dpgLogoLink",
    jepLogoLink: "jepLogoLink",
    cimLogoLink: "cimLogoLink",
    errorPrimaryCta: "errorPrimaryCta",
    errorSecondaryCta: "errorSecondaryCta",
    errorSearchCta: "errorSearchCta",
    bannerClose: "bannerClose",
    vtmGoBannerGoButton: "vtmGoBannerGoButton",
    vtmGoPlusBannerGoPlusButton: "vtmGoPlusBannerGoPlusButton",
    CPBDGoButton: "CPBDGoButton",
    bannerButton: "bannerButton",
    vtmNieuwsBannerButton: "vtmNieuwsBannerButton",
};
export var displayModeMapper = function (displayMode) {
    switch (displayMode) {
        case "Fullscreen":
            return "full";
        case "Content":
            return "content";
        case "Slot":
        default:
            return "slot";
    }
};
